import styled from 'styled-components'

const Span = styled.span`
  text-align: ${(p) => p.align};
  font-size: ${(p) => p.fontSize};
`

export default Span
